import {
    SUB_PROJECT_SET_STATUS,
    SUB_APPTOOLBAR_RESET_APP_STATE,
    PROJECTS_CRUD_SET_CURRENT_SUB_PROJECT,
    PROJECTS_CRUD_RESTORE_STATE,
    APPTOOLBAR_RESET_APP_STATE,
} from "../lib/types";
import produce from "immer";
import SubProject from "../lib/sub-project";

const initialState = {
    subProject: null,
    runSaveSubProject: false,
};

export let SubProjectReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUB_PROJECT_SET_STATUS:
            let project = new SubProject();
            const draft = produce(project, projectDraft => {
                projectDraft.subProject = state.subProject;
                projectDraft.subProject.processingStatus = (
                    action.payload.workItemStatus
                    || action.payload.processingStatus
                    || state.project.processingStatus
                );
            });
            return {
                ...state,
                project: draft,
            };

        case PROJECTS_CRUD_SET_CURRENT_SUB_PROJECT: //ok
            const stateDraft = produce(state, draft => {
                try {
                    draft["subProject"] = { ...action.payload };
                } catch (e) {
                    console.error(`SUB_PROJECTS_CRUD_SET_CURRENT_PROJECT stateDraft :: ${e.message}`);
                }
            },
            );
            return {
                ...stateDraft,
            };

        case PROJECTS_CRUD_RESTORE_STATE:
            let rState = action.payload.subProject;
            return {
                state,
                ...rState
            };


        case SUB_APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/sub-project-reducer.js